// @flow
import { get } from 'lodash';
import type { Service, ServicesMap } from '@zapier/services';

type ObjectWithSelectedApi = {
  selected_api: ?string,
};

type MaybeService = Service | void | null;

export default function getAssociatedService(
  obj: ?ObjectWithSelectedApi,
  services: ServicesMap
): MaybeService {
  if (!obj || !services || !obj.selected_api) {
    return null;
  }

  return get(services, obj.selected_api, null);
}
